import { Styles } from 'assets/types';

const formPageStyles: Styles = () => ({
  hidden: {
    display: 'none',
  },
});

export default formPageStyles;
